var map = {
	"./approval.svg": "804b",
	"./config.svg": "93ae",
	"./definition.svg": "7641",
	"./dept.svg": "302d",
	"./doing.svg": "8445",
	"./list.svg": "3561",
	"./log.svg": "9cb5",
	"./loginUser.svg": "953a",
	"./menu.svg": "f3d1",
	"./model.svg": "a44c",
	"./pass.svg": "6ead",
	"./pedding_approval.svg": "3ab5",
	"./role.svg": "193c",
	"./success_approval.svg": "1754",
	"./system.svg": "922f",
	"./todo.svg": "87cc",
	"./user.svg": "d88a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";